module.exports = __webpack_public_path__ + "static/img/voibook-app.ceee3e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/voibook-app.png
// module id = /IEY
// module chunks = 1